import { Input } from 'reactstrap'
import { publishEvent } from '../../utils'

export default function SearchFormOperatorPopup({ index, operators, onChangeFunction, defaultValue }) {
  console.log('SearchFormOperatorPopup rendered')

  const options = []
  operators.forEach((operator) => {
    options.push(<option key={operator.id} value={operator.id}>{operator.name}</option>)
  })

  function handleChange(event) {
    console.log('SearchFormOperatorPopup.handleChange', event)
    publishEvent(`OPERATOR POPUP CHANGED ${index}`, event.target.value, 'SearchFormOperatorPopup')
    onChangeFunction(event)
  }

  return (
    <Input index={index} type="select" name="operator" data-cy="search-form-operator" bsSize="sm" onChange={handleChange} defaultValue={defaultValue} >
      {options}
    </Input>
  )
}